export {AccountPage} from './Account';
export {AllProjectsPage} from './AllProjects';
export {ArchivePage} from './Archive';
export {AuthPage} from './Auth';
export {CommunityPage} from './Community';
export {NotesPage} from './Notes';
export {ProfilePage} from './Profile';
export {ProjectPage} from './Project';
export {RecentPage_Obsolete} from './Recent';
export {SettingsPage} from './Settings';
export {TemplatePage} from './Templates';
export {UpdatesPage} from './Updates';
export {ErrorPage} from './Error';
export {UsersInfoPage} from './UsersInfo';
export {ProjectsInfoPage_Obsolete} from './ProjectsInfo';
export {NewsPage} from './News';
export {ConfirmAccount} from './ConfirmAccount';


